import React from 'react';
import {
  Box,
  TextField,
  Grid,
  FormControlLabel,
  Checkbox
} from '@mui/material';
import type { Person } from '../../../../types';

interface DatesFormProps {
  data: Partial<Person>;
  errors: Record<string, string>;
  onChange: (field: string, value: any) => void;
  disabled?: boolean;
}

/**
 * DatesForm - Edit life dates
 *
 * Fields:
 * - Birth Date
 * - Death Date (disabled if not deceased)
 * - Is Deceased checkbox
 */
export const DatesForm: React.FC<DatesFormProps> = ({
  data,
  errors,
  onChange,
  disabled = false
}) => {
  // Format date for input (YYYY-MM-DD)
  const formatDateForInput = (dateString?: string): string => {
    if (!dateString) return '';
    try {
      const date = new Date(dateString);
      return date.toISOString().split('T')[0];
    } catch {
      return '';
    }
  };

  return (
    <Box sx={{ pt: 2 }}>
      <Grid container spacing={3}>
        {/* Birth Date */}
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            type="date"
            label="Birth Date"
            value={formatDateForInput(data.birthDate)}
            onChange={(e) => onChange('birthDate', e.target.value)}
            error={!!errors.birthDate}
            helperText={errors.birthDate}
            InputLabelProps={{ shrink: true }}
            disabled={disabled}
          />
        </Grid>

        {/* Is Deceased Checkbox */}
        <Grid item xs={12}>
          <FormControlLabel
            control={
              <Checkbox
                checked={data.isDeceased || false}
                onChange={(e) => onChange('isDeceased', e.target.checked)}
                disabled={disabled}
              />
            }
            label="Deceased"
          />
        </Grid>

        {/* Death Date */}
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            type="date"
            label="Death Date"
            value={formatDateForInput(data.deathDate)}
            onChange={(e) => onChange('deathDate', e.target.value)}
            error={!!errors.deathDate}
            helperText={errors.deathDate}
            InputLabelProps={{ shrink: true }}
            disabled={disabled || !data.isDeceased}
          />
        </Grid>
      </Grid>
    </Box>
  );
};
